export default ({ navigationList = [], isPipeSeparated = false }) => {
	return {
		isPipeSeparated,
		navigationList,
	};
};
